import { IndividualUserImpl } from "../data/IndividualUserImpl";
import { IIndividualUserRepository } from "../domain/repositories/IIndividualUserRepository";
import { IndividualUserUseCase } from "../domain/useCases/IndividualUserUseCase";
import { IndividualUsersManagementViewModel } from "../presentation/viewModel/IndividualUsersManagementViewModel";
import { InjectionBinding, InjectionModule } from "app/di/DependencyInjections";

export class IndividualUserInjection extends InjectionModule {
  private static readonly individualUserRepositoryToken = Symbol(
    "IIndividualUserRepository",
  );
  private static readonly individualUserUseCaseToken = Symbol(
    "IndividualUserUseCase",
  );
  private static readonly individualUsersManagementViewModelToken = Symbol(
    "IndividualUsersManagementViewModel",
  );

  protected static override bindings: InjectionBinding[] = [
    {
      scope: "otherRepo",
      token: this.individualUserRepositoryToken,
      useClass: IndividualUserImpl,
    },
    {
      scope: "otherRepo",
      token: this.individualUserUseCaseToken,
      useClass: IndividualUserUseCase,
    },
    {
      scope: "viewModel",
      token: this.individualUsersManagementViewModelToken,
      useClass: IndividualUsersManagementViewModel,
    },
  ];

  static getRepo(): IIndividualUserRepository {
    return this.resolve(this.individualUserRepositoryToken);
  }

  static getUseCase(): IndividualUserUseCase {
    return this.resolve(this.individualUserUseCaseToken);
  }
}
